function isEither<T1, T2>(obj): obj is Partial<T1 & T2> {
    return true;
}

namespace Portico {

	import pm = Portico.Models;
	import pmi = Portico.Models.Interfaces;
    import ps = Portico.Services;

    // Define the main app
    let app = angular.module('app', [
        'colorpicker.module',
        'ngFileUpload',
        'ngStorage',
        'ngDraggable',
        'ui.select',
        'ui.bootstrap',
        'ui.mask',
		'ui.router',
		'ui.scrollpoint'
    ]);

    class AppBootStrap {
        static bootAngular() {
            app.run([
				'$interval',
				'$log',
                '$q',
				'$rootScope',
				'$transitions',
                '$window',
				'actionService',
				'porticoService',
				'$state', (
					$interval: angular.IIntervalService,
					$log: angular.ILogService,
                    $q: angular.IQService,
					$rootScope: ng.IRootScopeService,
					$transitions: any,
                    $window: angular.IWindowService,
					actionService: ps.IActionService,
					porticoService: ps.IPorticoService,
                    $state: ng.ui.IStateService
                ) => {
					$log.info('App Started.');
					(<any>$rootScope).actionService = actionService;
					(<any>$rootScope).porticoService = porticoService;

                    (<any>window)["Promise"] = $window["Promise"] = $q;  // added to support async/await

                    $('body').tooltip({
                        selector: '[data-toggle="tooltip"]',
                        container: 'body'
                    });

                    $(document).on('mouseover', 'tc-mode-edit', (e) => {
                        e.stopPropagation();
                        $(e.currentTarget).addClass('hover');
                    });

                    $(document).on('mouseout', 'tc-mode-edit', (e) => {
                        e.stopPropagation();
                        $(e.currentTarget).removeClass('hover');
                    });

                    //$(document).on('hidden.bs.modal', () => {
                    //    if ($('.modal-backdrop').length > 0) {
                    //        $('body').addClass('modal-open');
                    //        $('body').css('padding-right', '17px');
                    //    } else {
                    //        $('body').removeClass('modal-open');
                    //        $('body').css('padding-right', '0');
                    //    }
                    //});

					$interval(() => {
						const useSession = porticoService.dataService.getDataValue('Reference', 'Id', 'use-session', '').toLowerCase() === 'true';

						if (useSession) {
							if (porticoService.authenticationService.hasSession()) {
								if (porticoService.dataService.session.user &&
									porticoService.dataService.getDataValue('Modal', 'Body', 'session-warning') &&
									porticoService.authenticationService.isExpiring()) {
									const scope = angular.element(document.getElementById('portico-app')).scope();
									porticoService.modalService.show2(scope, 'session-warning');
								}
							} else if (!porticoService.dataService.temp.creating_session) {
								porticoService.dataService.temp.creating_session = true;
								porticoService.authenticationService.createSession().then(() => {
									if (porticoService.dataService.session.user) {
										porticoService.dataService.session.user = null;
										porticoService.state(null, 'layout', 'home', null, null, { ppid: encodeURI(porticoService.dataService.state.fullRoute || '/app/layout/home'), psid: 'session-expired' });
									}
								}).finally(() => {
									porticoService.dataService.temp.creating_session = false;
								});
							}
						}
					}, 60000);

					$transitions.onError({}, (transition) => {
						if (!transition.ignored() && transition.error().type !== 2) {
							const stateChangeAction = porticoService.dataService.getDataValue('Resolve', 'Eval', 'stateChangeError');

							if (stateChangeAction) {
								eval(stateChangeAction);
							}

							//event.preventDefault();
							porticoService.state(null, 'layout', 'error');
						}
                    });

					$transitions.onStart({}, (transition) => {
						const stateChangeAction = porticoService.dataService.getDataValue('Resolve', 'Eval', 'stateChangeStart');

						if (stateChangeAction) {
							eval(stateChangeAction);
						}
                    });

					$transitions.onSuccess({}, (transition) => {
						const to = transition.to();
						const params = transition.params();
						const stateChangeAction = porticoService.dataService.getDataValue('Resolve', 'Eval', 'stateChangeSuccess');
                        const title = porticoService.dataService.getDataValue('Page', 'Title', porticoService.dataService.state.page);
						const useSession = porticoService.dataService.getDataValue('Reference', 'Id', 'use-session', '').toLowerCase() === 'true';

						porticoService.dataService.state.root = _.trimEnd(window.location.origin + window.location.pathname, '/') + '/';
						porticoService.dataService.state.fullRoute = transition.router.stateService.href(to.name, params);

						if (to.name === 'app.layout.page' || to.name === 'app.layout.page.intake.section') {
							// this is only needed for sites that actually use session
							if (useSession) {
								porticoService.authenticationService.touchSession();

								if (to.name === 'app.layout.page') {
									let value = null;
									if (!value) value = porticoService.dataService.getDataValue('Page', 'Features', `${params.app}.${params.layout}.${params.page}`);
									if (!value) value = porticoService.dataService.getDataValue('Page', 'Features', `${params.layout}.${params.page}`);
									if (!value) value = porticoService.dataService.getDataValue('Page', 'Features', `${params.page}`);
									if (!value) value = '';

									const features = _.difference(value.split(','), ['']);

									if (!porticoService.authenticationService.hasSession()) {
										if (!porticoService.dataService.temp.creating_session) {
											porticoService.dataService.temp.creating_session = true;
											//event.preventDefault();
											porticoService.authenticationService.createSession().then(() => {
												if (porticoService.dataService.session.user) {
													porticoService.dataService.session.user = null;
													if (params.page !== 'home') {
														porticoService.state(null, 'layout', 'home', null, null, { ppid: encodeURI(porticoService.dataService.state.fullRoute), psid: 'session-expired' });
													}
												}
											}).finally(() => {
												porticoService.dataService.temp.creating_session = false;
											});
										}
									} else if (!porticoService.authenticationService.isAuthenticated()) {
										//event.preventDefault();
										if (_.includes(features, 'Authenticated')) {
											if (params.page !== 'home') {
												porticoService.state(null, 'layout', 'home', null, null, { ppid: encodeURI(porticoService.dataService.state.fullRoute), psid: 'not-authenticated' });
											}
										}
									} else if (!porticoService.authenticationService.isAuthorized(features)) {
										//event.preventDefault();
										if (params.page !== 'unauthorized') {
											porticoService.state(null, 'layout', 'unauthorized');
										}
									}
								}
							}
						}

                        if (stateChangeAction) {
                            eval(stateChangeAction);
                        }

						if (porticoService.serverConstants.connectTo !== 'Prod') {
							//$window.document.title = `${porticoService.dataService.setup.portal.portalGroup.name} - ${porticoService.dataService.setup.portal.name} - ${porticoService.serverConstants.connectTo}`;
							$window.document.title = `${porticoService.dataService.setup.portal.name} - ${porticoService.serverConstants.connectTo}`;
						} else if (title) {
							$window.document.title = title;
						}

                        // autoscroll to top
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;

						// remove modal backdrop
						porticoService.modalService.clear();
                        $('body').removeClass('modal-open');
                        $('.modal').css('display', 'none');
                        $('.modal-backdrop').remove();
                    });
                }
            ])
            .config([
                '$controllerProvider',
                '$localStorageProvider',
                '$provide',
                '$httpProvider', (
                    $controllerProvider: angular.IControllerProvider,
                    $localStorageProvider: ps.IStorageProvider,
                    $provide: angular.auto.IProvideService,
                    $httpProvider: angular.IHttpProvider
                ) => {
                    // local storage configuration
                    $localStorageProvider.setKeyPrefix('portico_');
                    $localStorageProvider.setSerializer(angular.toJson);
                    $localStorageProvider.setDeserializer(angular.fromJson);
                    $httpProvider.interceptors.push('apiInterceptor');

                    (<any>app).$controllerProvider = $controllerProvider;
                    (<any>app).$provide = $provide;
                }
            ]);

            angular.bootstrap(document.body, ['app']);
        }
    }

    angular.element(document).ready(() => {
        AppBootStrap.bootAngular();
    });
}